const GET_KINDS = "GET_KINDS";

export { GET_KINDS };
